import React,{useEffect, useState} from 'react'
import SimpleTable from "../../../../../../../components/simpleTable/SimpleTable";
import { useDispatch , useSelector} from 'react-redux';
import CustomChip from "../../../../../../../components/customChip/CustomChip";
import CustomModal from "../../../../../../../components/customModal/CustomModal";
import './fuelLookUpStyle.css'
import ResponseHandler from '../../../../../../../services/ResponseHandler';
import { DeleteFuel, getAllFuels } from '../../../../../../../api/apiServices/fuelApi';
import FuelForm from './fuel_form/FuelForm';
import FuelLookUpFilter from './FuelFilter';

function FuelLookUp() {
const dispatch=useDispatch()
const [open, setOpen] = useState(false);
const [existingValue,SetExistingValue]=useState(null)
const [fuel,setfuel]=useState([])
const [rerenderUpdate,setrerenderUpdate]=useState(false)
const Fuel =useSelector((state)=>state.lookUpStore.Fuels)
    useEffect(() => {
        dispatch(getAllFuels())
          // .then((response) => {
          //   setfuel(response)
          // })
          // .catch((error) => {
          //   console.log(error);
          // });
      }, [rerenderUpdate]);
      const Columns = [
        {
          title: "#",
          dataIndex: "key",
          key: "key",
        },
        {
          title: "Fuel name",
          dataIndex: "fuel_name",
          key: "fuel_name",
        },
        {
          title: "Actions",
          dataIndex: "Actions",
          key: "Actions",
          action: (row) => (
            <div  className="fuel_lookup_action_chipset">
              <CustomChip text="Edit" bgColor="#F8893C" color="white" onClick={()=>{
                SetExistingValue(row)
                handleClickOpen()
              }} />
              <CustomChip text="Delete" bgColor="#ED5967" color="white" onClick={()=>{
                dispatch(DeleteFuel(row.id)).then((response)=>{
                  ResponseHandler(response)
                  setrerenderUpdate(!rerenderUpdate)
                }).catch((error)=>{
                  ResponseHandler(error)
                })
              }}/>
            </div>
          ),
        },
      ];
     
      const Datas=()=>{
        const result= Fuel &&  Fuel.map((item,index)=>{
          return{
            key:index+1,
            id:item.fl_id,
            fuel_name:item.fl_fuel
          }
        })
        return result
      }
      const handleClickOpen = () => {
        setOpen(true);
      };
      const handleClose = (state) => {
        setOpen(state);
        SetExistingValue(null)
        setrerenderUpdate(!rerenderUpdate)
      };
  return (
    <div>
    <div className="fuel_lookup_header">
       <div>
          <FuelLookUpFilter/>
       </div>
       <div>
       <button className="add_fuel_button" onClick={()=>{handleClickOpen()}}>
          Add Fuel
        </button>
       </div>
    </div>
    <CustomModal
          open={open}
          handleClose={handleClose}
          body={<FuelForm onClose={handleClose} existingvalue={existingValue}/>}
          title={existingValue?'Update Fuel':"Add Fuel"}
        />
     <SimpleTable columns={Columns} rows={Datas()}/>
  </div>
  )
}

export default FuelLookUp